<template>
	<div class="bg-white px-3 index" >
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="结算审核记录" name="1">
				<jsshjl />
			</el-tab-pane>
			<el-tab-pane label="转账记录" name="2">
				<zzjl />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import buttonSearch from "@/components/common/button-search.vue"
	import jsshjl from "./tabs/jsshjl.vue";
	import zzjl from "./tabs/zzjl.vue";
	export default {
		components: {
			buttonSearch,
			jsshjl,
			zzjl,
		},
		data() {
			return {
				tableData: [],
				currentPage: 1,
				multipleSelection: [],

				search: {
					time: "",
					keyword: ""
				},
				activeName: '1'
			}
		},
		created() {

		},
		methods: {
			// 选中
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除单个
			deleteItem(scope) {
				this.$confirm('是否要删除该规格?', '提示', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.tableData.splice(scope.$index, 1)
					this.$message({
						message: '删除成功',
						type: 'success'
					});
				})
			},
			handleClick(){}
		},
	}
</script>

<style>
	.sku-list-item>i {
		display: none;
		cursor: pointer;
	}

	.sku-list-item:hover {
		background-color: #f4f4f4;
	}

	.sku-list-item:hover>font {
		display: none;
	}

	.sku-list-item:hover>i {
		display: inline-block;
	}
</style>